import AppContext from "@/AppContext";
import { useUserPreferences } from "@/hooks/user_preferences";
import { useContext } from "react";
import toast from "react-hot-toast";
import UserPreferenceTopic from "../profile/UserPreferenceTopic";
import Spinner from "../Spinner";
import { Button } from "../ui/button";

function UserPreferences() {
  const context = useContext(AppContext);
  const { isUpdating, preferences, updatePreferences, toggleUserPreference } =
    useUserPreferences();

  const save = async (evt) => {
    evt.preventDefault();

    try {
      const response = await updatePreferences();
      toast.success("Preferences updated!");
    } catch (error) {
      toast.error("Failed to save preferences. Please try again!");
    }
  };

  return (
    <>
      <p className='mb-4 text-lg font-semibold text-white'>Topic Preferences</p>
      <form onSubmit={save}>
        <div className='grid grid-cols-2 gap-4 lg:grid-cols-4'>
          {context.state.topic_list.map((topic) => (
            <UserPreferenceTopic
              key={`pref-topic-${topic.uuid}`}
              topic={topic.name}
              thumbnail={topic.image_url}
              onChange={() => toggleUserPreference(topic.uuid)}
              uuid={topic.uuid}
              selected={preferences.includes(topic.uuid)}
              size='small'
            />
          ))}
        </div>
        <Button type='submit' className='mt-5'>
          {isUpdating && <Spinner />}
          {isUpdating ? "Updating..." : "Save Changes"}
        </Button>
      </form>
    </>
  );
}

export default UserPreferences;
